<article
  class="accordion xs--stack"
  [ngClass]="{
    active: isOpen,
    'accordion--reversed': isReversed,
    container: isStepper,
    'accordion--complete': hasStepperEdit
  }"
>
  <header *ngIf="!isStepper">
    <button
      type="button"
      class="link typog-body-large-bold"
      (click)="onToggleClick()"
      [attr.aria-expanded]="isOpen"
    >
      <ng-content select="[header]"></ng-content>
      <i class="fa-solid fa-chevron-down ml-2"></i>
    </button>
  </header>
  <header *ngIf="isStepper" class="stepper-header">
    <ng-content select="[stepperHeader]"></ng-content>
    <button
      type="button"
      class="link"
      (click)="onToggleClick()"
      [class.is-hidden]="!hasStepperEdit"
    >
      <span class="typog-body-large-bold link">Edit</span>
      <dgx-components-icon
        class="ml-2"
        [name]="'pen-to-square'"
        [size]="'md'"
      ></dgx-components-icon>
    </button>
  </header>
  <section *ngIf="isOpen" [@slideInOut]>
    <ng-content select="[content]"></ng-content>
  </section>
</article>
